// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__14xYR","header":"ClearentDisclaimer_header__3aUf-","inner":"ClearentDisclaimer_inner__3sc8n"};